import type { Translations } from "./en";

export const ar: Translations = {
  dir: "rtl",
  locale: "ar",
  common: {
    appName: "مدار منهم",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    create: "إنشاء",
    confirm: "تأكيد",
    loading: "جارٍ التحميل...",
    admin: "مشرف",
    user: "مستخدم",
  },
  nav: {
    dashboard: "الرئيسية",
    users: "المستخدمون",
    editor: "المحرر",
    documents: "المستندات",
    mappings: "القاموس",
    grammarRules: "قواعد التدقيق",
    settings: "الإعدادات",
  },
  editor: {
    title: "محرر المقالات بالذكاء الاصطناعي",
    input: "المقال المدخل",
    output: "نتيجة الذكاء الاصطناعي",
    process: "المعالجة بالذكاء الاصطناعي",
    save: "حفظ",
    selectPrompt: "المُوجِّه",
    selectProvider: "مزود الذكاء الاصطناعي",
    processing: "جارٍ المعالجة...",
    saved: "تم الحفظ بنجاح",
    error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
  },
  workbench: {
    title: "ورشة المقالات",
    source: "النص الإنجليزي",
    arabic: "المقال العربي",
    step1: "استبدال",
    step2: "ترجمة",
    step3: "مراجعة",
    step4: "عنوان",
    replace: "استبدال الكلمات",
    translate: "ترجمة",
    check: "فحص القواعد",
    generateTitles: "توليد العناوين",
    regenerate: "إعادة التوليد",
    accept: "قبول",
    reject: "رفض",
    noIssues: "لا ملاحظات",
    noIssuesLong: "لا توجد ملاحظات — النص ممتاز!",
    save: "حفظ المستند",
    saved: "تم الحفظ",
    error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    issues: "ملاحظات",
    allSuggestions: "كل الاقتراحات",
    closeDrawer: "إغلاق",
    freeEditHint: "تمت المراجعة — يمكنك التحرير بحرية الآن",
    outOfSync: "الاقتراح غير متزامن — أعد الفحص",
    titlesPlaceholder: "اضغط \"توليد العناوين\" للحصول على ٥ اقتراحات",
    arabicEmpty: "ترجم النص المصدر لتبدأ التحرير هنا",
    sourceHeading: "المصدر",
    collapse: "طيّ",
    expand: "توسيع",
    englishOriginal: "النص الإنجليزي الأصلي",
    englishReplaced: "النص الإنجليزي بعد الاستبدال",
    arabicResult: "النص العربي",
    noTitlesYet: "ستظهر العناوين المولدة هنا",
    approve: "قبول",
    keep: "إبقاء",
    kept: "مُبقى",
    undo: "تراجع",
    restore: "استعادة",
    approveAll: "قبول الكل",
    exitReview: "إنهاء المراجعة",
    pending: "قيد الانتظار",
    approved: "مقبولة",
    rejected: "مرفوضة",
    formattingSimplified: "تم تبسيط التنسيق بعد المراجعة — أعد تطبيقه عند الحاجة",
    backToEdit: "العودة للتحرير",
    translated: "تمت الترجمة",
    replaced: "تم الاستبدال",
    reviewed: "تمت المراجعة",
  },
  wizard: {
    stepEnglish: "النص الإنجليزي",
    stepReplace: "الاستبدال",
    stepTranslate: "الترجمة",
    stepReview: "المراجعة",
    stepTitle: "العنوان",
    headingEnglish: "النص الإنجليزي الأصلي",
    headingReplace: "استبدال الكلمات",
    headingTranslate: "الترجمة",
    headingReview: "مراجعة القواعد",
    headingTitle: "العنوان والحفظ",
    nextReplace: "التالي: استبدال الكلمات",
    nextTranslate: "التالي: الترجمة",
    nextReview: "التالي: المراجعة",
    nextTitle: "التالي: العنوان",
    back: "رجوع",
    replacing: "جارٍ استبدال الكلمات...",
    translating: "جارٍ الترجمة...",
    checking: "جارٍ فحص القواعد...",
    generatingTitles: "جارٍ توليد العناوين...",
    beforeLabel: "قبل",
    afterLabel: "بعد",
    wordsReplaced: "كلمة تم استبدالها",
    noErrors: "لا توجد أخطاء",
    enterTextFirst: "أدخل النص الإنجليزي أولاً",
    resetWarning: "إعادة تنفيذ هذه الخطوة ستعيد تعيين الخطوات التالية",
    changelogTitle: "سجل التغييرات",
    logEnglish: "تم إدخال النص الإنجليزي",
    logReplaced: "تم استبدال الكلمات",
    logWordsReplaced: "كلمة تم استبدالها",
    logTranslated: "تمت الترجمة عبر DeepL",
    logReviewed: "تمت مراجعة القواعد",
    logNoErrors: "لا توجد أخطاء",
    logSaved: "تم حفظ المستند",
    logTitleChosen: "العنوان",
    logCharacters: "حرف",
    logStep1: "تم إدخال النص الإنجليزي",
    logStep2: "تم استبدال الكلمات",
    logStep3: "تمت الترجمة عبر DeepL",
    logStep4: "تمت مراجعة القواعد",
    logStep5: "العنوان والحفظ",
    checkGrammar: "فحص القواعد",
    saveDocument: "حفظ المستند",
    next: "التالي",
  },
  pipeline: {
    step1Title: "المقال الإنجليزي",
    step1Button: "استبدال الكلمات",
    step1Result: "النص بعد الاستبدال",
    step2Title: "الترجمة (DeepL)",
    step2Button: "ترجمة باستخدام DeepL",
    step3Title: "مراجعة النص العربي",
    step3Button: "فحص القواعد",
    step3NoIssues: "لا توجد اقتراحات. النص ممتاز!",
    step3Accept: "قبول",
    step3Reject: "رفض",
    step4Title: "توليد العنوان",
    step4Button: "توليد عناوين",
    step4Regenerate: "إعادة التوليد",
    step4Placeholder: "العنوان النهائي",
    save: "حفظ المستند",
    saved: "تم الحفظ",
    errorRunStep1: "نفّذ الخطوة الأولى أولاً",
  },
  documents: {
    title: "مستنداتي",
    empty: "لا توجد مستندات بعد.",
    newDocument: "مستند جديد",
  },
  header: {
    logout: "تسجيل الخروج",
    adminPanel: "لوحة التحكم",
  },
  dashboard: {
    title: "لوحة التحكم",
    welcome: "مرحباً بعودتك إلى لوحة الإدارة.",
    currentUser: "المستخدم الحالي",
    name: "الاسم",
    email: "البريد الإلكتروني",
    role: "الدور",
  },
  users: {
    title: "المستخدمون",
    subtitle: "إدارة حسابات المستخدمين والأدوار.",
    name: "الاسم",
    email: "البريد الإلكتروني",
    role: "الدور",
    password: "كلمة المرور",
    created: "تاريخ الإنشاء",
    actions: "الإجراءات",
    noUsers: "لا يوجد مستخدمون.",
    addUser: "مستخدم جديد",
    editUser: "تعديل المستخدم",
    createUser: "إنشاء مستخدم",
    deleteUser: "حذف المستخدم",
    deleteConfirm: "هل أنت متأكد من حذف هذا المستخدم؟",
    passwordKeep: "اتركها فارغة للإبقاء على كلمة المرور الحالية",
    save: "حفظ",
    cancel: "إلغاء",
    create: "إنشاء",
  },
  mappings: {
    title: "قاموس الكلمات",
    subtitle: "إدارة قاموس استبدال الكلمات من الإنجليزية إلى العربية.",
    english: "الإنجليزية",
    arabic: "العربية",
    active: "مفعل",
    actions: "الإجراءات",
    new: "إضافة كلمة",
    edit: "تعديل الكلمة",
    delete: "حذف الكلمة",
    deleteConfirm: "هل أنت متأكد من حذف هذه الكلمة؟",
    noMappings: "لا توجد كلمات بعد.",
    duplicateError: "هذه الكلمة الإنجليزية موجودة مسبقاً.",
    save: "حفظ",
    cancel: "إلغاء",
  },
  grammarRules: {
    title: "قواعد التدقيق",
    subtitle: "إدارة قواعد التصحيح النحوي المبنية على التعبيرات النمطية.",
    name: "الاسم",
    description: "الوصف",
    reason: "السبب",
    pattern: "النمط",
    replacement: "الاستبدال",
    flags: "الأعلام",
    enabled: "مفعّل",
    sortOrder: "الترتيب",
    actions: "الإجراءات",
    new: "قاعدة جديدة",
    edit: "تعديل القاعدة",
    delete: "حذف القاعدة",
    deleteConfirm: "هل أنت متأكد من حذف القاعدة \"{name}\"؟",
    noRules: "لا توجد قواعد بعد.",
    save: "حفظ",
    cancel: "إلغاء",
    invalidRegex: "تعبير نمطي غير صالح",
    reasonHelp: "يدعم {{from}} و{{to}} و{{$1}} كعناصر نائبة.",
    patternHelp: "مصدر التعبير النمطي بدون محددات (مثال: \\bfoo\\b).",
    aiGenerate: "إنشاء بالذكاء الاصطناعي",
    aiPromptPlaceholder: "صف القاعدة التي تريد إنشاءها...",
    aiExampleInput: "مثال - النص قبل",
    aiExampleOutput: "مثال - النص بعد",
    generating: "جارٍ الإنشاء...",
    testTitle: "اختبار القاعدة",
    testPlaceholder: "اكتب نصاً تجريبياً...",
    runTest: "تشغيل الاختبار",
    noMatches: "لا توجد نتائج",
    matchesFound: "نتيجة",
    backToList: "العودة للقواعد",
    createRule: "إنشاء قاعدة",
    updateRule: "تحديث القاعدة",
  },
  settings: {
    title: "الإعدادات",
    subtitle: "إعدادات مزودي الذكاء الاصطناعي والترجمة وقوالب الأوامر.",
    tabs: {
      providers: "مزودو الذكاء الاصطناعي",
      deepl: "الترجمة",
      grammar: "مراجعة القواعد",
      titles: "توليد العناوين",
    },
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    saved: "تم الحفظ",
    activeProvider: "المزود النشط",
    apiKey: "مفتاح API",
    apiKeyFilled: "تم الإدخال",
    apiKeyPlaceholder: "أدخل مفتاح API",
    apiKeyKeep: "اتركه فارغاً للإبقاء على المفتاح الحالي",
    currentKey: "المفتاح الحالي",
    model: "النموذج",
    baseUrl: "رابط الخادم (اختياري)",
    providersSectionTitle: "مزودو الذكاء الاصطناعي",
    providersSectionSubtitle: "اختر المزود النشط وأعدّ بيانات الاعتماد لكل مزود.",
    grammarMode: "وضع التدقيق",
    grammarModeRegex: "محرك التعبيرات النمطية (موصى به)",
    grammarModeAi: "مزود الذكاء الاصطناعي",
    grammarModeDesc: "التعبيرات النمطية — فوري، حتمي، متوافق 100% مع القواعد (تشكيل/تنوين/ترقيم فقط).\nالذكاء الاصطناعي — يستخدم المزود النشط مع الموجه أدناه (مرن لكن قد يخطئ).",
    grammarSectionTitle: "مراجعة القواعد",
    grammarSectionSubtitle: "اختر محرك التدقيق النحوي وأعدّ القواعد.",
    titlesSectionTitle: "توليد العناوين",
    titlesSectionSubtitle: "القواعد وقالب الموجه المستخدم لتوليد اقتراحات العناوين العربية.",
    titleRules: "قواعد العناوين",
    titleRulesHelp: "قواعد حرة تُحقن في موجه العناوين.",
    arabicRulesHelp: "قواعد حرة تُحقن في موجه القواعد.",
    grammarPromptHelp: "استخدم {{grammar_rules}} و{{text}} كعناصر نائبة في قالب الموجه.",
    titlePromptHelp: "استخدم {{title_rules}} و{{text}} كعناصر نائبة.",
    deepl: {
      title: "ترجمة DeepL",
      subtitle: "إعدادات DeepL للترجمة من الإنجليزية إلى العربية.",
      apiKey: "مفتاح API",
      plan: "الخطة",
      planFree: "مجاني",
      planPro: "احترافي",
      sourceLang: "لغة المصدر",
      targetLang: "لغة الهدف",
    },
    arabicRules: "قواعد اللغة العربية",
    grammarPrompt: "موجه القواعد",
    titlePrompt: "موجه العناوين",
  },
  adminSettings: {
    title: "إعدادات المشرف",
    subtitle: "إدارة مزودي الذكاء الاصطناعي والموجهات وعرض المستندات.",
    tabProviders: "المزودون",
    tabPrompts: "الموجهات",
    tabDocuments: "المستندات",
    providers: {
      title: "مزودو الذكاء الاصطناعي",
      add: "مزود جديد",
      edit: "تعديل المزود",
      create: "إنشاء مزود",
      delete: "حذف المزود",
      deleteConfirm: "هل أنت متأكد من حذف هذا المزود؟",
      none: "لا يوجد مزودون.",
      name: "الاسم",
      type: "النوع",
      apiKey: "مفتاح API",
      apiKeyKeep: "اتركه فارغاً للإبقاء على المفتاح الحالي",
      modelName: "اسم النموذج",
      baseUrl: "رابط الأساس",
      isActive: "مفعل",
      isDefault: "افتراضي",
      created: "تاريخ الإنشاء",
      actions: "الإجراءات",
    },
    prompts: {
      title: "الموجهات",
      add: "موجه جديد",
      edit: "تعديل الموجه",
      create: "إنشاء موجه",
      delete: "حذف الموجه",
      deleteConfirm: "هل أنت متأكد من حذف هذا الموجه؟",
      none: "لا توجد موجهات.",
      name: "الاسم",
      content: "المحتوى",
      isDefault: "افتراضي",
      created: "تاريخ الإنشاء",
      actions: "الإجراءات",
    },
    documents: {
      title: "المستندات",
      none: "لا توجد مستندات بعد.",
      id: "المعرف",
      user: "المستخدم",
      status: "الحالة",
      created: "تاريخ الإنشاء",
      updated: "آخر تحديث",
    },
  },
  auth: {
    welcomeBack: "مرحباً بعودتك",
    signInSubtitle: "سجّل الدخول إلى حسابك للمتابعة",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    passwordLabel: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    signIn: "تسجيل الدخول",
    signingIn: "جارٍ تسجيل الدخول...",
    protectedArea: "منطقة محمية. للمخوّلين فقط.",
    adminDashboard: "لوحة الإدارة",
    brandDescription: "أدِر منصتك بأدوات قوية ورؤى فورية.",
    feature1: "تحليلات وتقارير فورية",
    feature2: "تحكم آمن بالوصول",
    feature3: "عمليات مبسّطة",
    invalidCredentials: "البريد أو كلمة المرور غير صحيحة",
    somethingWrong: "حدث خطأ. يرجى المحاولة مرة أخرى.",
  },
};
